/* Log View, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="log-view" class="entity-view">
      <v-card-title>View Log</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>


        </v-col>
        <v-col class="text-right">

        <v-btn
          color="secondary"
          class="me-3"
          :to="{ name: 'log-list'}"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiViewList }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-simple-table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Log Level</td>
        <td>{{ entity.Level }}</td>
      </tr>

      <tr>
        <td>Event</td>
        <td>{{ entity.Summary }}</td>
      </tr>

      <tr>
        <td>Location</td>
        <td>{{ entity.Name }}</td>
      </tr>

      <tr>
        <td>Info</td>
        <td>{{ entity.Detail }}</td>
      </tr>

      <tr>
        <td>Data</td>
        <td>{{ entity.Data }}</td>
      </tr>

      <tr>
        <td>Created</td>
        <td>{{ Display.DateTime(entity.Created) }}</td>
      </tr>

        </tbody>
      </v-simple-table>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'

import {
  mdiPencilOutline,
  mdiPlus,
  mdiViewList,
  mdiClose
} from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'

export default {
  setup() {

    const { route, router  } = useRouter();

    const entity = computed(() => store.state.app.Log);
    const loading = ref(false);

    const fetchData = (id) => {
      store
        .dispatch('app/fetchLog', {
          id: id
        })
        .then(response => {
          loading.value = false
        })
        .catch(error => {
          console.log(error);
          router.push({ name: 'log-list'});
        })
    }

    // fetch the user information when params change
    //watch(() => route.value.params.id, (id) => fetchData(id));

    // and call now
    fetchData(route.value.params.id);



    return {
      loading,
      entity,
      Display,

      icons: {
        mdiPencilOutline,
        mdiPlus,
        mdiViewList,
        mdiClose
      },
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-view::v-deep .v-data-table th:last-child {
  width: 66%;
}
</style>

